<template>
  <div>
    <common-header hidden />
    <div class="index pageIndex">
      <!-- 首页头部 -->
      <!-- <div class="index-head">
      <div class="container">
        <ul>
          <li class="login" v-if="!user.token">
            <router-link to="/login">登录</router-link>/
            <router-link to="/register">注册</router-link>
          </li>
          <li v-if="user.token">
            <el-button type="text" @click="logExit">退出</el-button>
          </li>
        </ul>
      </div>
      </div>-->

      <!-- 首页logo -->
      <div class="index-logo">
        <div class="container">
          <div class="logo-img" @click="toINdex">
            <img src="../../assets/image/logo3.png" />
          </div>
          <div class="index-search">
            <div class="search-input">
              <input type="text" v-model="keyWords" placeholder="请输入课程名称" />
            </div>
            <button class="search" @click="searchKeyWord"></button>
          </div>
        </div>
      </div>
      <!-- 首页分类 -->
      <div class="container">
        <div class="nav-item">
          <ul>
            <li class="alltype">
              <router-link to="/onlineclass">全部分类</router-link>
            </li>
            <NavList :showCenter="true" />
          </ul>
        </div>
      </div>
      <div class="types">
        <div class="nav-content">
          <el-carousel style="height:380px" autoplay loop>
            <el-carousel-item style="height: 380px" v-for="(item, index) in  CarouselItems" :key="index">
              <div class="bgBox" :style="{'background-image':`url(${item.image_url})`}"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="bannerBox">
          <div class="container" style="position: relative;">
            <HomeNav class="home-nav"></HomeNav>
            <div class="container overf-h" v-if="!user.token">
              <div class="home-login">
                <div class="mid">
                  <img v-if="!user.token" src="../../assets/image/home-login.png" alt srcset />
                  <img v-else src="../../assets/image/home-login.png" alt srcset />
                </div>
                <div class="button-box mid">
                  <router-link to="/login">
                    <el-button type="primary" class="login button">登录</el-button>
                  </router-link>
                  <router-link to="/register">
                    <el-button plain class="regist button">注册</el-button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="title">
          <div class="container title-box overf-h">
            <div class="overf-h title-left">
              <span class="float-l">在线报名</span>
            </div>
          </div>
          <div class="container" style="margin-top:30px">
            <el-row :gutter="30">
              <el-col :span="6" v-for="(item, index) in bmList" :key="index">
                <div @click="$router.push({path:'/baoming',query:{id:item.id}})">
                  <el-card shadow="hover" style="width:100%;height:100%;text-align:center;cursor:pointer">
                    <el-image style="width:70px;height:70px;margin-bottom:25px" :src="item.thumb_image"></el-image>
                    <h3 class="des ellipsis-1">{{item.name}}</h3>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div v-loading="loading" style="min-height:50vh">
        <!-- 班／级／课／程  -->
        <div>
          <div class="title">
            <div class="container title-box overf-h">
              <div class="overf-h title-left">
                <span class="float-l">热门服务</span>
              </div>
            </div>
          </div>
          <div class="container">
            <el-row :gutter="30">
              <el-col :span="8">
                <el-row>
                  <el-col :span="4">
                    <div class="leftBox">
                      <p style="padding-top:50px;font-size:18px;line-height:2;margin-bottom:50px">
                        岗
                        <br />位
                        <br />培
                        <br />训
                      </p>
                      <p class="moreLink">
                        <router-link to="/roomclass">更多&gt;</router-link>
                      </p>
                    </div>
                  </el-col>
                  <el-col :span="20">
                    <div class="rightBox" @click="$router.push({path:'/roomDetail',query:{id:classlist.id}})">
                      <el-image class="tImg" :src="classlist.thumb_image" lazy></el-image>
                      <div class="rName ellipsis-1">{{classlist.name}}</div>
                      <div class="rTime">
                        <label>开始时间:</label>
                        <span>{{classlist.begin_at}}</span>
                      </div>
                      <div class="rTime">
                        <label>结束时间:</label>
                        <span>{{classlist.end_at}}</span>
                      </div>
                      <el-rate :value="classlist.score-0" disabled></el-rate>
                      <div class="actBox">
                        <el-button type="text">进入学习</el-button>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="4">
                    <div class="leftBox">
                      <p style="padding-top:50px;font-size:18px;line-height:2;margin-bottom:50px">
                        宣
                        <br />贯
                        <br />课
                        <br />程
                      </p>
                      <p class="moreLink">
                        <router-link to="/recommendclass">更多&gt;</router-link>
                      </p>
                    </div>
                  </el-col>
                  <el-col :span="20">
                    <div class="rightBox" @click="toCourse(recommend.id)">
                      <el-image class="tImg" :src="recommend.thumb_image" lazy></el-image>
                      <div class="rName ellipsis-1">{{recommend.title}}</div>
                      <div class="rTime">
                        <label>时间:</label>
                        <span>{{recommend.course_total_time}}</span>
                      </div>
                      <div class="rTime">
                        <label>章节:</label>
                        <span>{{recommend.chapter_number}}(章节)</span>
                      </div>
                      <el-rate :value="recommend.score-0" disabled></el-rate>
                      <div class="actBox">
                        <el-button type="text">进入学习</el-button>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <div style="height:50px;background: #2a82e4;line-height:50px;text-align:center;color:#FFF;font-size:18px">文库免费资料查看</div>
                <div style="border:1px solid #EEE;padding:10px ">
                  <div style="height:198px">
                    <div class="fileItem ellipsis-1" v-for="item in newList" :key="item.id">
                      <a :href="item.file">{{item.title}}</a>
                    </div>
                  </div>

                  <div class="actBox">
                    <a href="/mylibrary">
                      <el-button type="text">查看更多</el-button>
                    </a>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 新／闻／咨／询 -->
        <div v-if="newsList.length>0">
          <div class="title">
            <div class="container title-box overf-h">
              <div class="overf-h title-left">
                <span class="float-l">新闻资讯</span>
              </div>
              <a class="float-r more" target="_blank" href="/news">更多</a>
            </div>
          </div>
          <ul class="news-list container">
            <li v-for="(item, index) in newsList" :key="index" @click="$router.push({path:'/newsdetail',query:{id:item.id}})">
              <div class="news-head">
                <el-image :src="item.thumbnail_image" lazy class="class-img"></el-image>
              </div>
              <div class="news-bottom">
                <span class="news-name">{{item.author}}</span>
                <a class="news-des ellipsis-2">{{item.title}}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 明/星/讲/师  -->
      <div v-if="teacherList.length>0" style="padding-bottom:50px">
        <div class="title">
          <div class="container title-box overf-h">
            <div class="overf-h title-left">
              <span class="float-l">明星讲师</span>
            </div>
            <a class="float-r more" target="_blank" href="/superteacher">更多</a>
          </div>
        </div>
        <ul class="teach-list container">
          <li v-for="(item, index) in teacherList" :key="index" @click="$router.push({path:'/teacherdetail',query:{id:item.id}})">
            <div class="teach-head">
              <el-image v-if="item.expert" :src="item.expert.avatar" fit="cover" lazy class="class-img"></el-image>
            </div>
            <div class="teach-name" v-if="item.expert&&item.expert.real_name">{{item.expert.real_name}}</div>
            <div class="teach-job" v-if="item.expert&&item.expert.professional">{{item.expert.professional}}</div>
            <div class="teach-introduce ellipsis-2 ritchHtml" v-if="item.expert&&item.expert.expertise" v-html="item.expert.expertise"></div>
          </li>
        </ul>
      </div>

      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import HomeNav from "../../components/HomeNav";
import Footer from "../../components/footer/Footer";
import NavList from "../../components/NavList";
import CommonHeader from "../../components/Header";
import { mapState, mapActions } from "vuex";
export default {
  name: "index",
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  components: {
    HomeNav,
    CommonHeader,
    Footer,
    NavList,
  },
  data() {
    return {
      keyWords: "",
      loading: false,
      recommend: {
        thumb_image: "",
      },
      newList: [],
      newsList: [],
      CarouselItems: [],
      classlist: {
        thumb_image: "",
      },
      teacherList: [],
      bmList: [
        { id: 1, thumb_image: require("@/assets/image/xx.png"), name: "新训" },
        { id: 2, thumb_image: require("@/assets/image/hz.png"), name: "换证" },
        { id: 3, thumb_image: require("@/assets/image/bk.png"), name: "补考" },
        { id: 4, thumb_image: require("@/assets/image/hz.png"), name: "增岗" },
      ],
    };
  },

  created() {
    this.getPageDate();
  },

  methods: {
    ...mapActions({
      logOut: "user/logOut",
    }),
    searchKeyWord() {
      if (!this.keyWords) {
        this.$message.error("请输入课程名称");
        return false;
      }
      this.$router.push({ path: "/search", query: { name: this.keyWords } });
    },
    toCourse(id) {
      this.$router.push({ path: "/classDetail", query: { id: id } });
    },
    logExit() {
      this.logOut();
      this.$router.push("login");
    },
    toINdex() {
      location.reload();
    },
    getPageDate() {
      this.$http({
        url: "/api/v1/banners",
        method: "get",
        params: { type: 4 },
      }).then((res) => {
        if (res.status == 200) {
          this.CarouselItems = res.data.banners;
        } else {
          this.$message.error(res.msg);
        }
      });
      this.$http({
        url: "api/v1/courses/recommend",
        method: "get",
        params: { page: 1, limit: 5 },
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.courses[0]) {
            this.recommend = res.data.courses[0];
          }
        } else {
          this.$message.error(res.msg);
        }
      });

      this.$http({
        url: "api/v1/files",
        method: "get",
        params: { page: 1, limit: 5 },
      }).then((res) => {
        if (res.status == 200) {
          this.newList = res.data.files;
        } else {
          this.$message.error(res.msg);
        }
      });

      this.$http({
        url: "api/v1/star-lecturers",
        method: "get",
        params: { page: 1, limit: 5 },
      }).then((res) => {
        if (res.status == 200) {
          this.teacherList = res.data.star_lecturers;
        } else {
          this.$message.error(res.msg);
        }
      });
      this.loading = true;
      this.$http({
        url: "api/v1/news",
        method: "get",
        params: { page: 1, limit: 4 },
      }).then((res) => {
        if (res.status == 200) {
          this.loading = false;
          this.newsList = res.data.news;
        } else {
          this.loading = false;
          this.$message.error(res.msg);
        }
      });
      this.$http({
        url: "/api/v1/classes",
        method: "get",
        params: { page: 1, limit: 5 },
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.classes[0]) {
            this.classlist = res.data.classes[0];
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" >
.pageIndex {
  .class-list {
    overflow: hidden;

    padding-right: 0;
    padding-left: 0;
    .el-card__body {
      padding: 10px;
    }
  }
}
.ritchHtml {
  font-size: 14px !important;

  b,
  p,
  span {
    font-size: 14px !important;
    font-weight: normal;
  }
}
</style>
<style lang="less" scoped>
// 首页头部
.index-head {
  height: 34px;
  background-color: rgba(229, 229, 229, 0.61);
  ul {
    line-height: 34px;
    width: 100%;
    overflow: hidden;
    li {
      float: right;
      color: rgba(80, 80, 80, 1);
      font-size: 14px;
      margin-left: 65px;
    }
    .vip {
      color: rgba(252, 131, 6, 1);
    }
    .login {
      a:hover {
        cursor: pointer;
        color: rgba(42, 130, 228, 1);
      }
    }
  }
}

// 首页logo
.index-logo {
  padding: 10px 0 20px 0;
  .container {
    overflow: hidden;
  }
}
.logo-img {
  width: 272px;
  height: 73px;
  float: left;
  cursor: pointer;
  img {
    height: 100%;
  }
}
.leftBox {
  height: 310px;
  text-align: center;
  color: #fff;
  background: #2a82e4;
  cursor: pointer;
  a {
    color: #fff;
    display: block;
  }
  .moreLink {
    height: 50px;
  }
}
.rightBox {
  border: 1px solid #eee;
  height: 310px;
  padding: 10px;
  .tImg {
    height: 146px;
    width: 100%;
  }
  .rName {
    font-size: 18px;
  }
  .rTime {
    padding: 2px 0;
    label {
      margin-right: 10px;
    }
  }
}
.actBox {
  text-align: center;
  button {
    width: 100%;
    height: 100%;
  }
}
.fileItem {
  padding: 8px 0;
}
.index-search {
  float: right;
  width: 423px;
  height: 35px;
  overflow: hidden;
  margin-top: 20px;
  .search-input {
    width: 323px;
    float: left;
    input {
      display: inline-block;
      box-sizing: border-box;
      width: 100%;
      border: none;
      height: 35px;
      font-size: 16px;
      padding: 0 12px;
      border: solid 2px rgba(42, 130, 228, 1);
    }
  }
  .search {
    width: 100px;
    height: 100%;
    float: left;
    cursor: pointer;
    background-color: rgba(42, 130, 228, 1);
    border: none;
    background-image: url("../../assets/image/search.svg");
    background-position: center;
    background-size: 80% 80%;
    background-repeat: no-repeat;
  }
}
// tab切换
.nav-item {
  height: 52px;
  margin: 0px auto;
}
.nav-item ul {
  list-style: none;
  /* margin-left: 15px; */
}
.nav-item li {
  width: 137px;
  float: left;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  line-height: 52px;
}
.nav-item a {
  text-decoration: none;
  color: #555555;
}
.nav-item a:hover {
  color: #d9534f;
}
.alltype {
  width: 200px !important;
  color: #fff;
  margin-left: 0 !important;
  background-color: rgba(42, 130, 228, 1);
  a {
    color: #fff;
  }
}
.active {
  color: rgba(42, 130, 228, 1) !important;
}
// <!-- 首页分类 -->
.types {
  height: 380px;
  background-image: url("../../assets/image/home-back.png");
  position: relative;
  .nav-content {
    width: 100%;
    height: 100%;
    .bgBox {
      width: 100%;
      height: 380px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .bannerBox {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
  }
}

.home-nav {
  width: 826px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.home-login {
  width: 244px;
  height: 292px;
  margin-top: 53px;
  background-color: #fff;
  float: right;
  padding-top: 20px;
  .mid {
    height: 200px;
    text-align: center;
    img {
      display: block;
      height: 167px;
      margin: 0 auto;
    }
  }
  .button {
    width: 88px;
    // height: 36px;
    border-radius: 9px;
  }
  .button-box {
    width: 200px;
    height: 36px;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .login {
    float: left;
    color: #fff;
    border: solid 1px rgba(42, 130, 228, 1);
    background-color: rgba(42, 130, 228, 1);
  }
  .regist {
    float: right;
    border: solid 1px rgba(42, 130, 228, 1);
    color: rgba(42, 130, 228, 1);
    background-color: #fff;
  }
}
// <!-- 推荐课程 -->
.title {
  padding: 42px 0;
}
.title-box {
  position: relative;
  .title-left {
    width: 100%;
    margin: 0 auto;
    font-size: 20px;
    font-weight: bold;
    color: #444;
  }
  .more {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 14px;
    color: #999;
  }
  .more:hover {
    color: rgba(42, 130, 228, 1);
  }
}
.class-list {
  overflow: hidden;

  padding-right: 0;
  padding-left: 0;
  .el-card__body {
    padding: 10px;
  }
}

.class-list li {
  width: 231px;
  height: 288px;
  line-height: 160%;
  float: left;
  margin-right: 11px;
  cursor: pointer;
  &:nth-child(5n) {
    margin-right: 0;
  }
  .class-img-box {
    width: 100%;
    height: 118px;
    overflow: hidden;
    margin-bottom: 8px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .class-img:hover {
    transform: scale(1.1);
  }
  .class-img {
    width: 231px;
    height: 128px;
    cursor: pointer;
    transition: all 0.6s;
  }
  .class-price {
    overflow: hidden;
  }
  .des {
    display: block;
    color: #444;
    font-size: 14px;
    height: 45px;
  }
  .teach {
    color: rgba(128, 128, 128, 1);
    font-size: 13px;
  }
  .class-price {
    color: rgba(212, 48, 48, 1);
    float: left;
  }
  .score {
    float: right;
  }
}
.class-list1 li {
  height: 270px;
}
// <!-- 明/星/讲/师  -->
.teach-list {
  padding-top: 42px;
  overflow: hidden;
}
.teach-list li {
  float: left;
  position: relative;
  transition: all 0.3s ease;
  background-color: rgba(42, 130, 228, 0.11428571428571431);
  border-radius: 11px;
  margin-right: 11px;
  width: 231px;
  padding: 20px 0;
}
.teach-list li:hover {
  cursor: pointer;
  margin-top: -8px;
  box-shadow: 0px 5px 3px rgba(42, 130, 228, 0.11428571428571431);
}

.teach-list li:nth-child(5n) {
  margin-right: 0;
}
.teach-head {
  width: 103px;
  height: 103px;
  margin: 10px auto 30px;
}
.teach-head .class-img {
  width: 103px;
  height: 103px;
  border-radius: 52px;
}
.teach-name {
  color: rgba(7, 17, 27, 1);
  font-size: 17px;
  font-weight: bold;
  text-align: center;
}
.teach-job {
  margin-top: 6px;
  text-align: center;
  color: rgba(77, 85, 93, 1);
  font-size: 13px;
}
.teach-introduce {
  font-size: 13px;
  color: rgba(77, 85, 93, 1);
  width: 154px;
  line-height: 150%;
  height: 45px;

  text-align: center;
  margin: 0 auto;
  margin-top: 23px;
}
// <!-- 新／闻／咨／询 -->

.news-list li {
  width: 290px;
  float: left;
  margin-right: 10px;
}
.news-list li:nth-child(4h) {
  margin-right: 0;
}
.news-list {
  overflow: hidden;
  .news-head {
    width: 290px;
    height: 223px;
    overflow: hidden;
    .class-img {
      width: 290px;
      height: 223px;
      cursor: pointer;
      transition: all 0.6s;
    }
    .class-img:hover {
      transform: scale(1.1);
    }
  }
}
.news-bottom {
  padding: 17px 15px;
  a {
    display: block;
  }
  .news-name {
    color: rgba(49, 65, 77, 1);
    font-size: 17px;
    margin-bottom: 10px;
  }
  .news-des {
    display: block;
    color: rgba(153, 170, 183, 1);
    font-size: 12px;
    line-height: 180%;
  }
}
</style>
